module.exports = __webpack_public_path__ + "static/media/sanjiao@3x.ff62c6aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/sanjiao@3x.png
// module id = 164
// module chunks = 0